import AbstractAccordion from '@/modules/common/common/models/APP/accordions/AbstractAccordion'
import Insurance from '@/modules/common/common/models/APP/Insurance'

export default class HealthInsurance extends Insurance {
  copayType: string | null
  copayText: string | null
  contractType?: string | null
  deficiencies: AbstractAccordion<any>
  coverages: AbstractAccordion<any>
  optionalCoverages: AbstractAccordion<any>
  coPayments: AbstractAccordion<any>
  insuranceType?: string | null
  abroadOption?: string | null

  constructor(data: Partial<HealthInsurance>) {
    super(data)
    this.copayType = data.copayType ?? null
    this.copayText = data.copayText ?? null
    this.contractType = data.contractType ?? null
    this.highlights = data.highlights ?? []
    this.deficiencies = data.deficiencies!
    this.coverages = data.coverages!
    this.optionalCoverages = data.optionalCoverages!
    this.coPayments = data.coPayments!
    this.deficiencies = data.deficiencies!
    this.sections = data.sections ?? []
    this.insuranceType = data.insuranceType ?? null
    this.abroadOption = data.abroadOption ?? null
  }

  getMandatoryFeatures() {
    return [this.coverages, this.optionalCoverages, this.coPayments, this.deficiencies]
  }
}
